import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// Tildelte oppdrag vises nå i arket over kartet på /driver (se ActiveOrderPanel).
// Ruten beholdes så eldre lenker, f.eks. fra varsler, fortsatt åpner riktig oppdrag.
export default function ActiveOrder() {
  const { orderId } = useParams();
  return <Navigate to={`/driver?active=${encodeURIComponent(orderId)}`} replace />;
}
